<script lang="ts">
	// Static for now, may implement dynamic later
	const submissionsThisMonth = 50;
</script>

<div class="animate-slide-down mb-8 rounded-lg border bg-white p-6 shadow-sm">
	<p class="text-foreground text-center text-base font-semibold">
		<span class="text-primary">🔥</span> Over {submissionsThisMonth} referrals submitted this month!
		Join others earning extra income.
	</p>
</div>
